import { useJobsQuery } from "@/hooks/useJobsQuery";
import { JobCard } from "./JobCard";
import { JobsLoadingState } from "./JobsLoadingState";
import { JobsErrorState } from "./JobsErrorState";
import { EmptyJobsList } from "./EmptyJobsList";
import type { JobFilters } from "./filters/JobFiltersModal";

interface JobsListProps {
  searchQuery?: string;
  filters?: JobFilters;
}

export const JobsList = ({ searchQuery, filters }: JobsListProps) => {
  const { jobs, isLoading, error } = useJobsQuery(searchQuery, filters);

  if (isLoading) return <JobsLoadingState />;
  if (error) return <JobsErrorState error={error as Error} />;
  if (jobs.length === 0) return <EmptyJobsList />;

  return (
    <div className="space-y-4">
      {jobs.map((job) => (
        <JobCard key={job.id} job={job} />
      ))}
    </div>
  );
};
